import React, { useEffect } from 'react';
import { object } from 'prop-types';
import FieldPropType from './BannerTemplateFieldPropType';
import { Label, FormGroup } from 'reactstrap';

import ColorPicker from 'components/ColorPicker/ColorPicker';
import { StyledInput, ColorPickerWrapper } from './HexColorInput.styled';

const DEFAULT_COLOR = '#FF0000';

const BannerLayerSourceFormHexColorInput = ({
  field,
  formState,
  inputProps
}) => {
  useEffect(() => {
    if (formState.values && !formState.values[field.label]) {
      formState.setField(field.label, DEFAULT_COLOR);
    }
  });

  const handleChange = color => formState.setField(field.label, color);

  return (
    <FormGroup>
      <Label
        id={`dyn_field_${field.key}Label`}
        htmlFor={`dyn_field_${field.key}`}
      >
        {field.label}
      </Label>
      <StyledInput
        {...inputProps}
        data-testid={`dyn_field_${field.key}Input`}
        id={`dyn_field_${field.key}`}
        aria-labelledby={`dyn_field_${field.key}Label`}
      />
      <ColorPickerWrapper>
        <ColorPicker
          color={inputProps.value || DEFAULT_COLOR}
          onChange={handleChange}
        />
      </ColorPickerWrapper>
    </FormGroup>
  );
};

BannerLayerSourceFormHexColorInput.propTypes = {
  formState: object,
  inputProps: object,
  field: FieldPropType
};

export default BannerLayerSourceFormHexColorInput;
